<template>
  <div>
    <b-container>
      <div class="mt-4 d-flex justify-content-between">
        <back-arrow :confirm="askConfirm" :params="{operationId: operationId, currentSection:0}"
                    :title="$t('Modify') + ' ' + $t('a.e')  + ' ' +  $t('operation')" route-back="OperationShow"/>
      </div>

      <div class="row">
        <div class="col-md-12">
          <b-card class="mt-2 mb-4 shadow-sm">
            <b-form v-unsave-detector @submit.stop.prevent="onSubmit">

              <div class="row">
                <div class="col-md-12 mb-2">
                  <span class="section-title">{{ $t('operation.General.infos') }}</span>
                </div>
              </div>

              <div class="row">
                <div class="col-md-8">

                  <div class="row">
                    <div class="col-md-6">
                      <b-form-group
                        :invalid-feedback="form.name.invalidFeedback"
                        :label="$t('operation.Name')"
                        :state="form.name.state"
                        class="medium-label mb-4"
                        label-for="name-input">
                        <b-form-input
                          id="name-input"
                          v-model="form.name.value"
                          :state="form.name.state"
                          maxlength="250"
                          required
                          type="text"
                          v-on:change="removeInvalidFeedback('name'); askConfirm=true;">
                        </b-form-input>
                      </b-form-group>
                    </div>

                    <div class="col-md-6">
                      <b-form-group
                        :invalid-feedback="form.address.invalidFeedback"
                        :label="$t('operation.Address')"
                        :state="form.address.state"
                        class="medium-label mb-4"
                        label-for="address-input">
                        <b-form-input
                          id="address-input"
                          v-model="form.address.value"
                          :state="form.address.state"
                          maxlength="250"
                          required
                          type="text"
                          v-on:change="removeInvalidFeedback('address'); askConfirm=true; ">
                        </b-form-input>
                      </b-form-group>
                    </div>

                    <div class="col-md-6">
                      <b-form-group
                        :invalid-feedback="form.postalCode.invalidFeedback"
                        :label="$t('operation.PostalCode')"
                        :state="form.postalCode.state"
                        class="medium-label mb-4"
                        label-for="postal-code-input">
                        <b-form-input
                          id="postal-code-input"
                          v-model="form.postalCode.value"
                          :state="form.postalCode.state"
                          maxlength="250"
                          required
                          type="text"
                          v-on:change="removeInvalidFeedback('postalCode'); askConfirm=true; ">
                        </b-form-input>
                      </b-form-group>
                    </div>

                    <div class="col-md-6">
                      <b-form-group
                        :invalid-feedback="form.city.invalidFeedback"
                        :label="$t('operation.City')"
                        :state="form.city.state"
                        class="medium-label mb-4"
                        label-for="city-input">
                        <b-form-input
                          id="city-input"
                          v-model="form.city.value"
                          :state="form.city.state"
                          maxlength="250"
                          required
                          type="text"
                          v-on:change="removeInvalidFeedback('city'); askConfirm=true;">
                        </b-form-input>
                      </b-form-group>
                    </div>

                    <div class="col-md-6">
                      <b-form-group
                        :invalid-feedback="form.estimatedStartDate.invalidFeedback"
                        :label="$t('operation.DateStart.label')"
                        :state="form.estimatedStartDate.state"
                        class="medium-label mb-4"
                        label-for="estimatedStartDate-input">
                        <datepicker-input
                          id="estimatedStartDate-input"
                          v-model="form.estimatedStartDate.value"
                          :state="form.estimatedStartDate.state"
                          required
                          v-on:input="removeInvalidFeedback('estimatedStartDate');">
                        </datepicker-input>
                      </b-form-group>
                    </div>

                    <div class="col-md-6">
                      <b-form-group
                        :invalid-feedback="form.estimatedEndDate.invalidFeedback"
                        :label="$t('operation.DateEnd.label')"
                        :state="form.estimatedEndDate.state"
                        class="medium-label mb-4"
                        label-for="estimatedEndDate-input">
                        <datepicker-input
                          id="estimatedEndDate-input"
                          v-model="form.estimatedEndDate.value"
                          :state="form.estimatedEndDate.state"
                          required
                          v-on:input="removeInvalidFeedback('estimatedEndDate');">
                        </datepicker-input>
                      </b-form-group>
                    </div>

                    <div class="col-md-6">
                      <b-form-group
                        :invalid-feedback="form.constructionStartDate.invalidFeedback"
                        :state="form.constructionStartDate.state"
                        class="medium-label mb-4"
                        label-for="constructionStartDate-input">

                        <b-tooltip html target="info-circle-construction-start" variant="dark">
                          {{ $t('operation.constructionStartDate.info') }}
                        </b-tooltip>
                        <label id="constructionStartDate-label" for="constructionStartDate-input">{{
                            $t('operation.constructionStartDate.label')
                          }}</label>
                        <b-icon id="info-circle-construction-start" class="ml-2" icon="info-circle"
                                variant="primary"></b-icon>

                        <datepicker-input
                          id="constructionStartDate-input"
                          v-model="form.constructionStartDate.value"
                          :state="form.constructionStartDate.state"
                          required
                          v-on:input="removeInvalidFeedback('constructionStartDate');">
                        </datepicker-input>
                      </b-form-group>
                    </div>

                    <div class="col-md-6">
                      <b-form-group
                        :invalid-feedback="form.constructionEndDate.invalidFeedback"
                        :state="form.constructionEndDate.state"
                        class="medium-label mb-4"
                        label-for="constructionEndDate-input">

                        <b-tooltip html target="info-circle-construction-end" variant="dark">
                          {{ $t('operation.constructionEndDate.info') }}
                        </b-tooltip>
                        <label id="constructionEndDate-label"
                               for="constructionEndDate-input">{{ $t('operation.constructionEndDate.label') }}</label>
                        <b-icon id="info-circle-construction-end" class="ml-2" icon="info-circle"
                                variant="primary"></b-icon>


                        <datepicker-input
                          id="constructionEndDate-input"
                          v-model="form.constructionEndDate.value"
                          :state="form.constructionEndDate.state"
                          required
                          v-on:input="removeInvalidFeedback('constructionEndDate');">
                        </datepicker-input>
                      </b-form-group>
                    </div>


                    <div class="col-md-6">
                      <b-form-group
                        :invalid-feedback="form.acteAchat.invalidFeedback"
                        :state="form.acteAchat.state"
                        class="medium-label mb-4"
                        label-for="acteAchat-input">

                        <b-tooltip html target="info-circle-acte-achat" variant="dark">
                          {{ $t('operation.acteAchat.info') }}
                        </b-tooltip>
                        <label id="acteAchat-label" for="acteAchat-input">{{
                            $t('operationPlanning.operation.acte.achat') + ' ' + this.operation.bilanType
                          }}</label>
                        <b-icon id="info-circle-acte-achat" class="ml-2" icon="info-circle"
                                variant="primary"></b-icon>

                        <datepicker-input
                          id="acteAchatDate-input"
                          v-model="form.acteAchat.value"
                          :state="form.acteAchat.state"
                          required
                          v-on:input="removeInvalidFeedback('acteAchat');">
                        </datepicker-input>
                      </b-form-group>
                    </div>

                    <div class="col-md-6">
                      <b-form-group
                        :label="$t('operationConstruction.operationType')"
                        class="medium-label mb-4"
                        label-for="uniteConstruction-input">
                        <b-form-select
                          id="uniteConstruction-input"
                          v-model="form.operationType.value"
                          v-on:change="manageOperationType"
                          required>
                          <option v-for="(operation, index) in operationTypes" :key="index" :value="operation.value">
                            {{ $t(operation.text) }}
                          </option>
                        </b-form-select>
                      </b-form-group>
                    </div>

                  </div>
                </div>

                <div class="col-md-4">
                  <div class="row">

                    <div class="col-md-12">
                      <b-form-group
                        class="medium-label mb-4">
                        <div class="d-flex">
                          <label for="picture-input">
                            {{ $t('operation.Picture') }}
                          </label>
                          <span class="ml-1">{{ $t('f.facultative.for.label') }}</span>
                        </div>
                        <custom-form-file
                          id="picture-input"
                          v-model="form.picture.value"
                          :drop-placeholder="$t('drop-placeholder')"
                          :placeholder="form.picture.value"
                          :state="form.picture.state"
                          accept=".png, .jpeg, .jpg"
                          @preview="imagePreview = $event"
                          @input="askConfirm=true"
                        />
                        <div>
                          <img v-if="imagePreview" :src="imagePreview" alt="Image preview" class=" mt-1 preview-image"/>
                          <img v-else-if="!imagePreview&&this.operation.picture"
                               :src="getFileUrl(this.operation.picture.fileUrl)" alt="Image preview"
                               class=" mt-1 preview-image"/>
                        </div>
                      </b-form-group>
                    </div>

                  </div>
                </div>
              </div>

              <template v-if="form.operationType.value && form.operationType.value !=='DEFAULT'">
                <div class="row mb-4">
                  <div class="col-md-12">
                    <div class="d-flex flex-column">
                      <span class="section-title">{{
                          $t('operation.General.VIRVEFA', {type: form.operationType.value})
                        }}</span>
                      <span class="virvefa-subtitle mt-1">{{ $t('operation.General.VIRVEFA.subtitle') }}</span>
                    </div>

                    <schedule-vir-vefa :initial-schedule="form.schedule.value" :need-amount-preview="false"
                                       @schedule-changed="scheduleChanged"></schedule-vir-vefa>

                  </div>
                </div>
              </template>

              <div class="d-flex justify-content-end">
                <b-button id="validate-btn" type="submit" variant="primary">{{ $t('Validate') }}</b-button>
              </div>
            </b-form>
          </b-card>

          <b-card v-if="this.operation.operationBilans && this.operation.operationBilans.length > 0">
            <div class="row">
              <div class="col-md-12 mb-2">
                <span class="section-title">{{ $t('operation.Bilan.infos') }}</span>
                <div v-for="bilan in this.operation.operationBilans" class="row mt-3">
                  <div class="col-12 mb-2">
                    <div class="d-flex">
                            <span :class="`bilan-${bilan.bilanType.toLowerCase()} `"
                                  class="bilanType-vignette">{{ bilan.bilanType }} </span>
                      <div class="ml-2  medium-label  d-flex align-items-center">
                        {{
                          $t('operation.bilan.edit', {
                            date: new Date(bilan.creationDate).toLocaleDateString()
                          })
                        }}
                      </div>
                      <div v-if="bilan.canDelete"
                           class="d-flex align-items-center ml-1 p-1 main-red-color cursor-pointer"
                           @click="removeBilan(bilan)">
                        <trash-icon size="18"/>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </b-card>
        </div>
      </div>
    </b-container>

  </div>
</template>

<script>

import api from '../../services/api'
import BackArrow from '../../components/b122/BackArrow'
import OperationLots from "./components/OperationLots"
import DatepickerInput from "../../components/b122/editFields/DatepickerInput.vue";
import ScheduleVirVefa from "./components/ScheduleVirVefa";
import CustomFormFile from "../../components/b122/editFields/CustomFormFile.vue";


export default {

  name: 'OperationEdit',

  components: {
    BackArrow,
    OperationLots,
    DatepickerInput,
    ScheduleVirVefa,
    CustomFormFile
  },

  data() {
    return {
      operationId: this.$route.params.operationId,
      operation: {},
      imagePreview: null,
      askConfirm: false,
      operationTypes: [],

      form: {
        name:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        address:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        postalCode:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        city:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        picture:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        schedule:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        operationType:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        estimatedStartDate:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        estimatedEndDate:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        constructionStartDate:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        constructionEndDate:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        acteAchat:
          {
            state: null,
            invalidFeedback: null,
            value: null
          }
      }
    }
  },


  mounted() {
    this.fetchData()
  },

  watch: {
    'form.operationType.value': function(newValue, oldValue) {
      if ((newValue === 'DEFAULT' || newValue === 'CLASSIQUE') &&
        (oldValue === 'VIR' || oldValue === 'VEFA') &&
        this.form.schedule.value && this.form.schedule.value.hasOwnProperty('id') &&
        this.form.schedule.value.id > 0) {

        this.confirmOperationTypeChange(newValue, oldValue);
      }
    }
  },

  methods: {

    confirmOperationTypeChange(newValue, oldValue) {
      this.$fire({
        title: 'Confirmation',
        html: `<div style="text-align: left;">
            <p>En passant à une opération de type ${newValue === "DEFAULT" ? "CLASSIQUE" : newValue}, vous allez perdre les échéanciers existants.</p>
            <p><strong>Attention :</strong> Cette action est irréversible.</p>
            <p style="margin-top: 15px;">Êtes-vous sûr de vouloir continuer ?</p>
           </div>`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Oui, continuer',
        cancelButtonText: 'Annuler',
        reverseButtons: true,
        customClass: {
          popup: 'custom-popup-class',
          content: 'custom-content-class'
        }
      }).then((result) => {
        console.log(result)
        if (result.value) {
          this.form.schedule.value = [];
        } else {
          this.form.operationType.value = oldValue;
        }
      });
    },

    async removeBilan(bilan) {
      if (bilan && bilan.hasOwnProperty('bilanType') && bilan.bilanType === "EXE") {
        this.$confirm(this.$i18n.t('operation.bilan.delete.exe.confirm').toString()).then(async () => {
          await api({
            method: 'POST',
            url: '/operation/deleteBilanEXE/' + this.operationId,
          })
            .then(async () => {
              await this.fetchOperation()
            })
        });
      }
    },

    getFileUrl(itemUrl) {
      return process.env.SERVER_URL + itemUrl
    },

    async fetchData() {
      await this.fetchOperationTypes()
      await this.fetchOperation()
    },

    async fetchOperationTypes() {
      api
        .get('/operation/getAllOperationTypes')
        .then(response => {
          this.operationTypes = response.data
        })
    },

    scheduleChanged(schedule, isValid) {
      this.form.schedule.state = isValid
      this.form.schedule.invalidFeedback = null
      this.form.schedule.value = schedule
    },

    async fetchOperation() {
      await api
        .get(`/operation/${this.operationId}`)
        .then(response => {
          this.operation = response.data
          this.form.name.value = response.data.name
          this.form.address.value = response.data.address
          this.form.postalCode.value = response.data.postalCode
          this.form.city.value = response.data.city
          if (response.data.estimatedStartDate != null && response.data.estimatedStartDate !== 0) {
            this.form.estimatedStartDate.value = (new Date(response.data.estimatedStartDate).toLocaleDateString()).split("/").reverse().join("-")
          }
          if (response.data.estimatedEndDate != null && response.data.estimatedEndDate !== 0) {
            this.form.estimatedEndDate.value = (new Date(response.data.estimatedEndDate).toLocaleDateString()).split("/").reverse().join("-")
          }
          if (response.data.constructionStartDate != null && response.data.constructionStartDate !== 0) {
            this.form.constructionStartDate.value = (new Date(response.data.constructionStartDate).toLocaleDateString()).split("/").reverse().join("-")
          }
          if (response.data.constructionEndDate != null && response.data.constructionEndDate !== 0) {
            this.form.constructionEndDate.value = (new Date(response.data.constructionEndDate).toLocaleDateString()).split("/").reverse().join("-")
          }
          if (response.data.acteAchat != null && response.data.acteAchat !== 0) {
            this.form.acteAchat.value = (new Date(response.data.acteAchat).toLocaleDateString()).split("/").reverse().join("-")
          }
          this.form.operationType.value = response.data.operationType
          this.form.schedule.value = response.data.schedule
          this.form.picture.value = response.data.picture && response.data.picture.hasOwnProperty('filename') ? response.data.picture.filename : null
        })
    },


    onSubmit() {
      const isFormInvalid = Object.values(this.form).some(field => field.state === false);
      if (isFormInvalid) {
        return;
      }

      let data = new FormData()
      data.append('name', this.form.name.value)
      data.append('address', this.form.address.value)
      data.append('postalCode', this.form.postalCode.value)
      data.append('city', this.form.city.value)
      data.append('picture', this.form.picture.value)
      if (this.form.estimatedStartDate.value != null) {
        data.append('estimatedStartDate', this.form.estimatedStartDate.value)
      }
      if (this.form.estimatedEndDate.value != null) {
        data.append('estimatedEndDate', this.form.estimatedEndDate.value)
      }
      if (this.form.constructionStartDate.value != null) {
        data.append('constructionStartDate', this.form.constructionStartDate.value)
      }
      if (this.form.constructionEndDate.value != null) {
        data.append('constructionEndDate', this.form.constructionEndDate.value)
      }
      if (this.form.acteAchat.value != null) {
        data.append('acteAchat', this.form.acteAchat.value)
      }
      data.append('operationType', this.form.operationType.value)
      data.append('schedule', JSON.stringify(this.form.schedule.value))

      api({
        method: 'PUT',
        url: `/operation/${this.operationId}`,
        data: data
      })
        .then(async response => {
          await this.generateMonthlyCharges()
          this.$router.push({
            name: 'OperationShow',
            params: {
              operationId: response.data.id,
              currentSection: 0
            }
          }, () => {
            this.$nextTick(() => {
              this.successToast(this.form.name.value)
            })
          })

        })
        .catch((error) => {
          if (error.response.status === 401 || error.response.status === 404) {
            this.$router.push({
              name: 'OperationIndex',
              params: {
                message: error.response.data.message
              }
            })
          } else if (error.response.status === 403) {
            const invalidField = error.response.data.invalidField
            this.form[invalidField]['state'] = false
            this.form[invalidField]['invalidFeedback'] = this.$i18n.t(error.response.data.message)
          }
        })
    },

    async generateMonthlyCharges() {

      let data = new FormData()
      data.append('operationId', this.operationId)

      api({
        method: 'POST',
        url: '/treasury/generateMonthlyCharges',
        data: data
      })
        .catch((error) => {
          if (error.response.status === 401 || error.response.status === 404) {
            this.$router.push({
              name: 'OperationShow',
              params: {
                operationId: this.operationId,
                currentSection: 2,
                message: error.response.data.message
              }
            })
          }
        })
    },

    removeInvalidFeedback(field) {
      this.form[field]['state'] = null
    },

    successToast(operationName) {
      this.$bvToast.toast(this.$i18n.t('Operation') + ' "' + operationName + '" ' + this.$i18n.t('f.modified'), {
        autoHideDelay: 4000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true,
        variant: "success",
        solid: true,
      })
    },

    manageOperationType() {
      if (this.form.operationType.value !== "DEFAULT") {
        api({
          method: 'GET',
          url: '/user/canUseVirVefa',
        }).then((response) => {
          if (!response.data.virVefaEnabled) {
            this.form.operationType.value = "DEFAULT"
            this.showCustomConfirm(
              this.$i18n.t('virVefa.message').toString(),
              this.$i18n.t('Ok')
            );
          }
        })
      }
    },

    showCustomConfirm(message, okText, cancelText) {
      return new Promise((resolve) => {
        this.$bvModal.msgBoxOk(message, {
          okTitle: okText,
          centered: true,
          okVariant: 'primary'
        })
          .then((confirmed) => {
            resolve(confirmed);
          })
          .catch(() => {
            resolve(false);
          });
      });
    },
  }
}
</script>

<style scoped>


.bilanType-vignette {
  color: var(--main-white);
  text-align: center;
  font: normal normal normal 10px/13px Montserrat-Bold, "Arial", sans-serif;
  letter-spacing: 1px;
  width: 40px;
  height: 20px;
  border-radius: 4px;
  opacity: 1;
  padding: 0.5em;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
}

.medium-label {
  font-family: "Montserrat-Medium", "Arial", sans-serif;
}
.virvefa-subtitle{
  color: var(--grey);
  font-weight: 500;
  font-size: 12px;
  line-height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/operation/OperationEdit.vue